module.exports = __webpack_public_path__ + "static/media/10.de735679.jpg";